import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SignIn } from 'auth/index';
import { OnboardingTemplate } from 'src/layout/OnboardingTemplate';
import { onboardingClerkAppearance } from 'src/layout/OnboardingTemplate/clerkAppearance';
import {
  homePath, newUserPath, signUpPath, withBasePath,
} from 'src/routes/constants';
import { readSignInRedirect } from 'src/routes/signInRedirect';

const pathWithSearchParams = (path: string, searchParamString: string) => {
  return path + (searchParamString ? `?${searchParamString}` : '');
};

export const SignInPage: FC = () => {
  const [searchParams] = useSearchParams();
  // Someone sent here from a page they opened signed out goes back to that page; anyone else goes home.
  const { returnTo, rest: searchParamString } = readSignInRedirect(searchParams);

  return (
    <OnboardingTemplate>
      <SignIn
        appearance={onboardingClerkAppearance}
        signUpUrl={withBasePath(pathWithSearchParams(signUpPath, searchParamString))}
        forceRedirectUrl={withBasePath(returnTo ?? pathWithSearchParams(homePath, searchParamString))}
        signUpForceRedirectUrl={withBasePath(pathWithSearchParams(newUserPath, searchParamString))}
      />
    </OnboardingTemplate>
  );
};
